import api from './axios';

export function getTeamSops() {
  return api.get('/sops').then((r) => r.data);
}

export function createTeamSop(body) {
  return api.post('/sops', body).then((r) => r.data);
}

export function updateTeamSop(id, body) {
  return api.put(`/sops/${id}`, body).then((r) => r.data);
}

export function deleteTeamSop(id) {
  return api.delete(`/sops/${id}`).then((r) => r.data);
}
